import { render, staticRenderFns } from "./Ads.vue?vue&type=template&id=fee4440e&scoped=true&"
import script from "./Ads.vue?vue&type=script&lang=js&"
export * from "./Ads.vue?vue&type=script&lang=js&"
import style0 from "./Ads.vue?vue&type=style&index=0&id=fee4440e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee4440e",
  null
  
)

export default component.exports